import './sections/index.js';
import './blocks/index.js';
import './elements/index.js';
import * as matchMedia from './modules/match-media.js';

matchMedia.set('wide', '(min-width: 1441px)');
matchMedia.set('large', '(min-width: 1025px) and (max-width: 1440px)');
matchMedia.set('medium', '(min-width: 761px) and (max-width: 1024px)');
matchMedia.set('small', '(max-width: 760px)');
